import React from 'react';
import { motion } from 'framer-motion';
import Container from '../ui/Container';
import './VisionStory.css';

const VisionStory = () => {
  return (
    <section className="ft-vision">
      <Container>
        <motion.div
          className="ft-vision__inner"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="ft-vision__eyebrow">Our Vision</span>

          <h2 className="ft-vision__title">
            좋은 서비스는
            <br />
            빨리 만들어 봐야 압니다.
          </h2>

          <p className="ft-vision__body">
            기획서만으로는 사람들이 쓸지 알 수 없습니다.
            <br />
            그래서 오래 다듬는 대신 작게 만들어 내놓고,
            <br />
            쓰는 사람의 반응으로 다음을 정합니다.
          </p>

          <p className="ft-vision__signature">
            우리는 그 방식으로 서비스를 늘려가고 있습니다.
          </p>
        </motion.div>
      </Container>
    </section>
  );
};

export default VisionStory;
